<template>
  <div id="root" :class="vueAppClasses">
    <auth v-if="userIsGuest"></auth>
    <splash v-else-if="!showApp"></splash>
    <switch-provider v-else-if="!isProviderSelected()"></switch-provider>
    <app v-else @setAppClasses="setAppClasses" />
    <windows-version />
  </div>
</template>

<script>
import theme from "./theme.js";
import Splash from "./views/Splash.vue";
import Auth from "./views/auth/Auth.vue";
import SwitchProvider from "./views/provider/SwitchProvider.vue";
import WindowsVersion from "./WindowsVersion.vue";
import App from "./App.vue";
import { mapState } from "vuex";
import Cookies from "js-cookie";
import authService from "./services/AuthService";

export default {
  components: {
    Splash,
    Auth,
    SwitchProvider,
    App,
    WindowsVersion,
  },
  data() {
    return {
      vueAppClasses: [],
    };
  },
  computed: {
    ...mapState({
      showSwitchProvider: (store) => store.profile.selectedProvider === -1,
      showApp: (store) => {
        return (
          ["READY", "UPDATING"].includes(store.profile.myProfile.status) &&
          ["READY", "UPDATING"].includes(store.profile.managedProviders.status)
        );
      },
      userIsGuest: (store) => {
        return !store.auth.isAuthenticated;
      },
    }),
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    async checkEmployeeToken() {
      const result = await Cookies.get("employee_login");
      if (result) {
        const userDetails = JSON.parse(result);
        authService.login({
          ...userDetails,
          phone: userDetails?.user?.phone,
          privileged: userDetails.privileged,
        });
        this.$store.commit("auth/LOGIN");
        this.$store.dispatch("profile/SELECT_PROVIDER", null);
        await Cookies.remove("employee_login", {
          path: "",
          domain: ".topmenumarket.com",
        });
        this.$router.go();
      }
    },
    isProviderSelected() {
      if (this.$store.state.profile.selectedProvider > 0) {
        return true;
      }

      return false;
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.checkEmployeeToken();

    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();

      if (localStorage.getItem("beforeinstallprompt") === "true") return;

      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "اضافه کردن به صفحه اصلی",
        text: "جهت استفاده بهتر و راحت تر از وب اپلیکیشن Top Menu پیشنهاد میکنیم آنرا به صفحه اصلی اضافه کنید.",
        acceptText: "اضافه کردن به صفحه اصلی",
        cancelText: "انصراف",
        accept: () => {
          event.prompt();
          localStorage.setItem("beforeinstallprompt", "true");
        },
        cancel: () => {
          localStorage.setItem("beforeinstallprompt", "true");
        },
      });
    });

    this.toggleClassInBody(theme.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
